import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import ReactToPrint from "react-to-print";
import html2canvas from "html2canvas";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import * as XLSX from "xlsx/xlsx.mjs";

// component
import { base64ToBlob, convertCurrency, numberFormat } from "../../helper";
import { errorSwal, successUpdateSwal } from "../../helper/sweetalert";
import BillforSale80 from "../../components/bill/BillforSale80";
import CustomButton from "../../components/CustomButton";
import { BLUETOOTH_PORT, COLOR_RED_500, COLOR_WHITE_200, ENTERNET_PORT, LINEAR_GRADIENT_BG, S3_URL, USB_PORT, USER_KEY } from "../../const";

// apollo-client
import {
  RETURN_ORDER_GROUP,
  UPDATE_PAID_V2,
} from "../../apollo/ordergroup/mutation";
import { GET_ORDERGROUP } from "../../apollo/ordergroup/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_PRINTERS } from "../../apollo/printer/Query";

// react-icons
import { MdOutlineQuestionMark } from "react-icons/md";
import PrintIcon from "@mui/icons-material/Print";
import { MdAttachMoney } from "react-icons/md";

// react-bootrap
import { Modal, Spinner } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import ComfirmModal from "../../components/ComfirmModal";
import BillOfferPriceV3 from "../../components/bill/BillOfferPriceV3";
import BillOfferPriceV2 from "../../components/bill/BillOfferPriceV2";
import { GET_SHOP } from "../../apollo/shop/Query";

export default function HIstoryIndebtedInfo() {
  const Location = useLocation();
  const shop = JSON.parse(localStorage.getItem("SHOP_DATA"));
  const history = useHistory();
  let bill80Ref = useRef(null);
  let bill80PrintRef = useRef(null);
  let bill58PrintRef = useRef(null);
  let componentRef = useRef();
  const [showUpdatePaid, setShowUpdatePaid] = useState(false);
  const shopIdPrinter = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
    ?.id;
  const [showConfirmReturnOrder, setShowConfirmReturnOrder] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [ordergroupData, setOrderGroupData] = useState();
  const [ordergroup, setOrderGroup] = useState();
  const [printer, setPrinter] = useState();
  const [isBillOfferPrice, setIsBillOfferPrice] = useState("BILL_OFFPRICE_V1");
  const [shopData, setShopData] = useState();
  const [isExporting, setIsExporting] = useState(false);


  // ============== > UseLazyQuery And UseMutaion <==============

  const [loadorder, { data: getorder, loading }] = useLazyQuery(
    GET_ORDERGROUP,
    { fetchPolicy: "network-only" }
  );
  const [getPrinterDatas, { data: printerDatas, loading: printerLoading }] =
    useLazyQuery(GET_PRINTERS, {
      fetchPolicy: "cache-and-network",
    });
  const [updatePaidV2, { loading: loadingUpdatePaid }] = useMutation(UPDATE_PAID_V2);
  const [returnordergroup, { loading: loadingreturnordergroup }] =
    useMutation(RETURN_ORDER_GROUP);
    const [loadShop, { data: loadShopData, loading: loadingShop }] = useLazyQuery(
      GET_SHOP,
      {
        fetchPolicy: "network-only",
      }
    );

  // ============== > useEffect <==============
  useEffect(() => {
    const shopSettingData = JSON.parse(localStorage.getItem("SHOP_SETTING_DATA"));
    setIsBillOfferPrice(shopSettingData?.isBillOfferPrice);
  }, []);

  useEffect(() => {
    _fetchorder();
    _fetchPrinter();
  }, []);

  useEffect(() => {
    if (!getorder?.orderGroup) return;
    setOrderGroup(getorder?.orderGroup?.orders);
    setOrderGroupData((prev) => ({
      ...prev,
      ...getorder?.orderGroup,
      orders: getorder?.orderGroup?.orders ?? prev?.orders,
    }));
  }, [getorder]);

  useEffect(() => {
    setOrderGroupData(Location?.state?.state);
    _fetchShop()
  }, []);

  useEffect(() => {
    if (printerDatas) setPrinter(printerDatas?.printers?.data);
  }, [printerDatas]);

  useEffect(() => {
    if (loadShopData) {
      setShopData(loadShopData?.shop);
    }
  }, [loadShopData]);

  // ============== > fuctions <==============
  

  const _fetchShop = () => {
    loadShop({
      variables: {
        where: {
          id: shop?.id,
        },
      },
    });
  };

  const _fetchorder = async () => {
    await loadorder({
      variables: {
        where: {
          id: Location?.state?.state?.id,
        },
      },
    });
  };

  const _fetchPrinter = async () => {
    await getPrinterDatas({
      variables: {
        where: {
          shop: shopIdPrinter,
          isDeleted: false,
          status: true
        },
      },
    });
  };

  const _updatePaid = async () => {
    try {
      if (loadingUpdatePaid) return;
      await updatePaidV2({
        variables: {
          where: {
            id: Location?.state?.state?.id,
          },
        },
      });

      successUpdateSwal("ຈ່າຍເງີນໃບບິນນີ້ສຳເລັດ");
      setShowUpdatePaid(false);
      history.goBack();
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const _ReturnOrderGroup = async () => {
    try {
      if (loadingreturnordergroup) return;
      await returnordergroup({
        variables: {
          orderBy: "createdAt_DESC",
          where: {
            id: Location?.state?.state?.id,
          },
        },
      });
      successUpdateSwal("ສົ່ງຄືນສິນຄ້າສຳເລັດ");
      history.goBack();
    } catch (err) {
      errorSwal("ໄດ້ສົ່ງຄືນອໍເດີນີ້ເເລ້ວ");
    }
  };

  // ================== Print bill ===============

  const handleExportExcel = async () => {
    try {
      if (isExporting) return;
      setIsExporting(true);

      const orderGroupId = Location?.state?.state?.id || ordergroupData?.id || getorder?.orderGroup?.id;
      let og = getorder?.orderGroup || ordergroupData || Location?.state?.state;

      if (orderGroupId && (!og?.customerName || !og?.phone || !og?.createdAt || !Array.isArray(og?.orders))) {
        const result = await loadorder({
          variables: {
            where: { id: orderGroupId },
          },
        });
        og = result?.data?.orderGroup || og;
      }
      const orders = (og?.orders || []).filter((o) => !o?.isDeleted);
      const createdAtText = (Location?.state?.state?.createdAt || og?.createdAt || og?.paymentDate || og?.checkBillDate)
        ? moment(Location?.state?.state?.createdAt || og?.createdAt || og?.paymentDate || og?.checkBillDate).format("DD/MM/YYYY HH:mm")
        : "";
      const customerNameText =
        og?.customerName ||
        og?.cfName ||
        `${og?.userConfirm?.name ?? ""} ${og?.userConfirm?.lastname ?? ""}`.trim() ||
        "";
      const phoneText = og?.phone || og?.userConfirm?.phone || "";
      const baseRow = {
        ເລກທີບິນ: og?.code ?? "",
        ຊື່ລູກຄ້າ: customerNameText,
        ເບີໂທ: phoneText,
        ສະຖານະ: og?.status ?? "",
        ວັນທີ: createdAtText,
        ຍອດເງີນ: og?.sumPrice ?? 0,
        ສະກຸນເງິນ: og?.currency ?? "",
      };

      const rows = [];
      if (orders.length === 0) {
        rows.push({ ...baseRow, ຊື່ສິນຄ້າ: "", ຈຳນວນ: "", ຂະໜາດ: "", ລາຄາ: "", ລວມ: "" });
      } else {
        orders.forEach((o) => {
          const size = o?.stock?.size || "";
          const unitName = o?.stock?.unitId?.name || o?.stock?.unit || "";
          const sizeDisplay = size ? `${size} ${unitName}` : unitName;
          const row = {
            ...baseRow,
            ຊື່ສິນຄ້າ: o?.productName ?? "",
            ຈຳນວນ: o?.amount ?? "",
            ຂະໜາດ: sizeDisplay,
            ລາຄາ: o?.price ?? 0,
            ລວມ: o?.totalPrice ?? 0,
          };
          rows.push(row);
        });
      }

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `indebted_${og?.code || "bill"}_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
    } catch (error) {
      console.log("Export Error:", error);
    } finally {
      setIsExporting(false);
    }
  };

  const onPrintBill = async () => {
    try {
      const printerBillData = printer?.find((e) => e?.status === true);
      if (!printerBillData) {
        await Swal.fire({
          icon: "warning",
          title: "ບໍ່ພົບປີນເຕີ້ທີ່ເລືອກໄວ້",
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }

      let urlForPrinter = "";
      if (printerBillData?.type === "ETHERNET") {
        urlForPrinter = ENTERNET_PORT;
      }
      if (printerBillData?.type === "BLUETOOTH") {
        urlForPrinter = BLUETOOTH_PORT;
      }
      if (printerBillData?.type === "USB") {
        urlForPrinter = USB_PORT;
      }
      if (!urlForPrinter) {
        await Swal.fire({
          icon: "warning",
          title: "ປະເພດປີນເຕີ້ບໍ່ຖືກຕ້ອງ",
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }

      const is80 = printerBillData?.width === "80mm" || !printerBillData?.width;
      const targetRef = is80 ? bill80PrintRef : bill58PrintRef;
      const targetEl = targetRef?.current;
      const targetWidth = targetEl?.offsetWidth || 0;
      if (!targetEl || targetWidth <= 0) {
        await Swal.fire({
          icon: "error",
          title: "ບໍ່ສາມາດສ້າງຮູບບິນໄດ້",
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }

      let dataImageForPrint;
      dataImageForPrint = await html2canvas(targetEl, {
        useCORS: true,
        scrollX: 10,
        scrollY: is80 ? 2 : 0,
        scale: is80 ? 560 / targetWidth : 350 / targetWidth,
      });

      const _file = await base64ToBlob(dataImageForPrint.toDataURL());

      var bodyFormData = new FormData();
      bodyFormData.append("ip", printerBillData?.ip);
      bodyFormData.append("port", "9100");
      bodyFormData.append("image", _file);
      bodyFormData.append("beep1", 1);
      bodyFormData.append("beep2", 9);

      const res = await axios({
        method: "post",
        url: urlForPrinter,
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res?.status === 200) {
        await Swal.fire({
          icon: "success",
          title: "ປິນສຳເລັດ",
          showConfirmButton: false,
          timer: 1500,
        });
        setShowModal(false);
      }
    } catch (err) {
      const detail =
        err?.response?.data?.message ||
        err?.message ||
        (typeof err === "string" ? err : "");
      await Swal.fire({
        icon: "error",
        title: "ປິນບໍ່ສຳເລັດ",
        text: detail ? `${detail}` : undefined,
        showConfirmButton: false,
        timer: detail ? 2500 : 1500,
      });
    }
  };

  // console.log("ordergroupData :",ordergroupData);
  // console.log("Location :",Location?.state?.state);
  
  

  return (
    <React.Fragment>
      <div className="purchaseorderlistdetail-main">
        <BreadCrumbComponent
          goback={() => history.goBack()}
          txtFirst="ປະຫວັດການຕິດໜີ້"
          txtSecond={`ລາຍການປິນ`}
          txtThir={`ຂໍ້ມູນບິນ`}
        />
        {/* <div style={{ padding: '2em' }}>
          <h4>
            <b>ໃບບິນຂອງລູກຄ້າ</b>
          </h4>
          <p>
            ຂໍ້ມູນລະລະອຽດທັງໝົດຂອງໃບບິນທີ່ຕິດໜິ້.
          </p>
        </div> */}


       <div className="purchaseorderlistdetail-content">
          <div className="purchaseorderlistdetail-A4" ref={componentRef} style={{ padding: "15px 25px", backgroundColor: "#fff", boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
            {isBillOfferPrice === "BILL_OFFPRICE_V3" ? (
              <BillOfferPriceV3 shopData={shopData} orderGroupData={ordergroupData ?? Location?.state?.state} />
            ) : isBillOfferPrice === "BILL_OFFPRICE_V2" ? (
              <BillOfferPriceV2 shopData={shopData} localOrder={Location?.state?.state} />
            ) : (
              <div style={{ fontFamily: "Noto Sans Lao, sans-serif", fontSize: "12px" }}>
                {/* Bill Header */}
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "24px",
                    marginTop: "5px",
                    marginBottom: "10px",
                    fontWeight: "bold",
                    color: "#3C169B"
                  }}>
                  ໃບບິນເເຈ້ງໜີ້
                </div>
                
                {/* Shop Info Section - Compact */}
                <div
                  style={{
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "5px",
                    marginBottom: "8px"
                  }}>
                  <div style={{ marginRight: "10px" }}>
                    <img
                      src={S3_URL + shop?.image ?? "../../../assets/image/cficon.png"}
                      width={60}
                      style={{ borderRadius: "5px" }}
                      alt="Shop Logo"
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "2px" }}>
                      ຮ້ານ: {shop?.name}
                    </div>
                    <div style={{ fontSize: "11px", color: "#555", marginBottom: "2px" }}>
                      ທີ່ຢູ່: {shop?.address?.village}, {shop?.address?.district}, {shop?.address?.province}
                    </div>
                    <div style={{ fontSize: "11px", color: "#555" }}>
                      ເບີໂທ: {shop?.phone}
                    </div>
                  </div>
                </div>
                
                {/* Customer and Invoice Info - Compact */}
                <div
                  style={{
                    display: "flex",
                    marginBottom: "8px",
                    gap: "8px"
                  }}>
                  {/* Customer Info */}
                  <div
                    style={{
                      width: "50%",
                      padding: "8px",
                      borderRadius: "5px",
                      border: "1px solid #e0e0e0",
                      backgroundColor: "#f8f9fa",
                      fontSize: "11px"
                    }}>
                    <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "3px", color: "#3C169B" }}>ຂໍ້ມູນລູກຄ້າ</div>
                    <div style={{ marginBottom: "2px" }}>
                      <span style={{ fontWeight: "bold" }}>ພ/ງຂາຍ:</span> {Location?.state?.state?.staff} {Location?.state?.state?.staffLastname}
                    </div>
                    <div style={{ marginBottom: "2px" }}>
                      <span style={{ fontWeight: "bold" }}>ລູກຄ້າ:</span> {Location?.state?.state?.customerName} {Location?.state?.state?.customerLastName}
                    </div>
                    <div style={{ marginBottom: "2px" }}>
                      <span style={{ fontWeight: "bold" }}>ທີ່ຢູ່:</span> {Location?.state?.state?.village ? Location?.state?.state?.village + "," : ""}
                      {Location?.state?.state?.district ? Location?.state?.state?.district + "," : ""}
                      {Location?.state?.state?.province ? Location?.state?.state?.province : ""}
                    </div>
                    <div>
                      <span style={{ fontWeight: "bold" }}>ເບີໂທ:</span> {Location?.state?.state?.phone}
                    </div>
                  </div>
                  
                  {/* Invoice Info */}
                  <div
                    style={{
                      width: "50%",
                      padding: "8px",
                      borderRadius: "5px",
                      border: "1px solid #e0e0e0",
                      backgroundColor: "#f8f9fa",
                      display: "flex",
                      flexDirection: "column",
                      // justifyContent: "center",
                      fontSize: "11px"
                    }}>
                    <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "3px", color: "#3C169B" }}>ຂໍ້ມູນໃບບິນ</div>
                    <div style={{ marginBottom: "2px" }}>
                      <span style={{ fontWeight: "bold" }}>ເລກທີບິນ:</span> {Location?.state?.state.code}
                    </div>
                    <div>
                      <span style={{ fontWeight: "bold" }}>ວັນທີ:</span> {moment(Location?.state?.state?.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                    </div>
                  </div>
                </div>

                {/* Product Table - Ultra Compact */}
                <div style={{ marginBottom: "8px" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "10px" }}>
                    <thead>
                      <tr style={{ backgroundColor: "#3C169B", color: "white" }}>
                        <th style={{ fontSize: "14px", fontWeight: "bold", padding: "3px 4px", textAlign: "center", borderRight: "1px solid #ddd", width: "50px" }}>ລຳດັບ</th>
                        <th style={{ fontSize: "14px", fontWeight: "bold", padding: "3px 5px", textAlign: "left", borderRight: "1px solid #ddd" }}>ຊື່ສິນຄ້າ</th>
                        <th style={{ fontSize: "14px", fontWeight: "bold", padding: "3px 4px", textAlign: "center", borderRight: "1px solid #ddd", width: "50px" }}>ຈຳນວນ</th>
                        <th style={{ fontSize: "14px", fontWeight: "bold", padding: "3px 5px", textAlign: "right", borderRight: "1px solid #ddd" }}>ລາຄາ</th>
                        <th style={{ fontSize: "14px", fontWeight: "bold", padding: "3px 5px", textAlign: "right", borderRight: "1px solid #ddd" }}>ລວມລາຄາ</th>
                        <th style={{ fontSize: "14px", fontWeight: "bold", padding: "3px 4px", textAlign: "center", width: "70px" }}>ສະກຸນເງີນ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ordergroupData?.orders?.map((purchaseorder, index) => (
                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white", lineHeight: "1.1" }}>
                          <td style={{ fontSize: "14px", padding: "2px 4px", textAlign: "center", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd" }}>
                            {index + 1}
                          </td>
                          <td style={{ fontSize: "14px", padding: "2px 5px", textAlign: "left", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {purchaseorder?.productName}
                          </td>
                          <td style={{ fontSize: "14px", padding: "2px 4px", textAlign: "center", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd" }}>
                            {purchaseorder?.amount}
                          </td>
                          <td style={{ fontSize: "14px", padding: "2px 5px", textAlign: "right", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd" }}>
                            {purchaseorder?.price ? numberFormat(purchaseorder?.price) : "-"}
                          </td>
                          <td style={{ fontSize: "14px", padding: "2px 5px", textAlign: "right", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd" }}>
                            {numberFormat(purchaseorder?.totalPrice)}
                          </td>
                          <td style={{ fontSize: "14px", padding: "2px 4px", textAlign: "center", borderBottom: "1px solid #ddd" }}>
                            {convertCurrency(purchaseorder?.currency)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                
                {/* Payment Summary Section */}
                <div
                  style={{
                    display: "flex",
                    marginBottom: "8px",
                    gap: "8px",
                    flexWrap: "wrap",
                    justifyContent: "space-between"
                  }}>    
                  {
                    (Location?.state?.state?.debt || Location?.state?.state?.cash || Location?.state?.state?.transfer
                    || Location?.state?.state?.discount > 0) && (
                    <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "20px", marginRight: "auto" }}>
                    <div style={{ width: "280px", backgroundColor: "#f8f9fa", padding: "8px", borderRadius: "5px", border: "1px solid #e0e0e0", fontSize: "11px" }}>
                      <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "3px", color: "#3C169B" }}>ສະຫຼຸບຍອດຊຳລະ</div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px"}}>
                        <div>ສ່ວນຫລຸດ:</div>
                        <div style={{ fontWeight: "500" }}>
                          {numberFormat(Location?.state?.state?.discount ?? 0)} {Location?.state?.state?.discountType ? "₭" : "%"}
                        </div>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                        <div>ເງີນສົດ:</div>
                        <div style={{ fontWeight: "500" }}>{numberFormat(Location?.state?.state?.cash ?? 0)} ₭</div>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                        <div>ເງີນໂອນ:</div>
                        <div style={{ fontWeight: "500" }}>{numberFormat(Location?.state?.state?.transfer ?? 0)} ₭</div>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                        <div>ຕີດຫນີ້:</div>
                        <div style={{ fontWeight: "500" }}>{numberFormat(Location?.state?.state?.debt ?? 0)} ₭</div>
                      </div>
                    </div>
                  </div>
                    )
                  }
                  {/* Summary Section - Compact */}
                  <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px", marginLeft: "auto" }}>
                    <div style={{ width: "280px", backgroundColor: "#f8f9fa", padding: "8px", borderRadius: "5px", border: "1px solid #e0e0e0", fontSize: "11px" }}>
                      <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "3px", color: "#3C169B" }}>ສະຫຼຸບລາຍການ</div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                        <div>ຍອດລວມກີບ:</div>
                        <div style={{ fontWeight: "500" }}>{numberFormat(Location?.state?.state?.totalPrice ?? 0)} ₭</div>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                        <div>ຍອດລວມບາດ:</div>
                        <div style={{ fontWeight: "500" }}>{numberFormat(Location?.state?.state?.sumPriceBaht ?? 0)} ฿</div>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                        <div>ຍອດລວມໂດລາ:</div>
                        <div style={{ fontWeight: "500" }}>{numberFormat(Location?.state?.state.sumPriceUsd ?? 0)} $</div>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "3px", paddingTop: "3px", borderTop: "1px dashed #ccc" }}>
                        <div style={{ fontSize: "14px", fontWeight: "bold" }}>ລາຄາລວມທັງໝົດ:</div>
                        <div style={{ fontWeight: "bold", fontSize: "14px", color: "#3C169B" }}>
                          {numberFormat(Location?.state?.state.sumPrice ?? 0)} {convertCurrency(Location?.state?.state?.currency)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Signature Section - Compact */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "10px",
                    paddingTop: "5px",
                    borderTop: "1px dashed #ccc",
                    fontSize: "11px"
                  }}>
                  <div style={{ width: "45%", textAlign: "center" }}>
                    <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "50px" }}>ຜູ້ຂາຍ</div>
                    <div style={{ borderTop: "1px solid #333", width: "80%", margin: "0 auto" }}></div>
                  </div>
                  <div style={{ width: "45%", textAlign: "center" }}>
                    <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "50px" }}>ລູກຄ້າເຊັນຮັບເຄື່ອງ</div>
                    <div style={{ borderTop: "1px solid #333", width: "80%", margin: "0 auto" }}></div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "50px 0",
          }}>
          <div>
            <ReactToPrint
              trigger={() => (
                <CustomButton
                  title=" ພິມບິນ"
                  icon={<PrintIcon />}
                  width={140}
                  height={42}
                  borderRadius={4}
                  background="green"
                />
              )}
              content={() => componentRef.current}
            />
          </div>
          &emsp;
          <CustomButton
            onClick={() => setShowModal(true)}
            width={140}
            height={42}
            background={COLOR_RED_500}
            borderRadius={4}
            title={"ພິມບິນ 80mm"}
          />
          &emsp;
          <CustomButton
            onClick={() => setShowUpdatePaid(true)}
            width={140}
            icon={<MdAttachMoney size={20} />}
            height={42}
            background={LINEAR_GRADIENT_BG}
            borderRadius={4}
            title=" ຈ່າຍເງີນ"
          />
          &emsp;
          <CustomButton
            onClick={() => setShowConfirmReturnOrder(true)}
            width={140}
            height={42}
            background={LINEAR_GRADIENT_BG}
            borderRadius={4}
            title={"ສົ່ງຄືນ"}
          />
          &emsp;
          <CustomButton
            onClick={() =>
              history.push("/sale/limit/50/page/1", {
                state: ordergroupData,
                isEdited: true,
                indebted: true,
              })
            }
            width={140}
            height={42}
            background={LINEAR_GRADIENT_BG}
            borderRadius={4}
            title={"ເເກ້ໄຂ"}
          />
          &emsp;
          <CustomButton
            onClick={handleExportExcel}
            width={140}
            height={42}
            background="green"
            borderRadius={4}
            title={isExporting ? "ກຳລັງບັນທຶກ..." : "Export Excel"}
            disabled={isExporting}
          />
           
        </div>
      </div>

      {/* print bill */}

      <div style={{ position: "absolute", top: "-9999px", left: 0 }}>
        <div style={{ width: "80mm" }} ref={bill80PrintRef}>
          <BillforSale80 Location={Location} ordergroup={ordergroup} />
        </div>
        <div style={{ width: "58mm" }} ref={bill58PrintRef}>
          <BillforSale80 Location={Location} ordergroup={ordergroup} />
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Body style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ width: "80mm" }} ref={bill80Ref}>
            <BillforSale80 Location={Location} ordergroup={ordergroup} />
          </div>
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
          <CustomButton
            width={140}
            height={42}
            borderRadius={4}
            background="transparent"
            color="#3C169B"
            border="1px solid #3C169B "
            fontweight={400}
            title={"ຍົກເລີກ"}
            onClick={() => setShowModal(false)}
          />
          &ensp;
          <CustomButton
            width={140}
            height={42}
            background={LINEAR_GRADIENT_BG}
            borderRadius={4}
            title={"OK"}
            onClick={() => onPrintBill()}
          />
        </Modal.Footer>
      </Modal>

      {/* return order */}

      <ComfirmModal
        showConfirmModal={showConfirmReturnOrder}
        handleCancel={() => setShowConfirmReturnOrder(false)}
        handleConfirm={_ReturnOrderGroup}
        title="ແຈ້ງເຕືອນ"
        loadingConfirm={loadingreturnordergroup}
        text={"ທ້ານຕ້ອງການສົ່ງຄືນສິນຄ້ານີ້ແທ້ ຫຼື ບໍ່ "}
      />

      <ComfirmModal
        showConfirmModal={showUpdatePaid}
        handleCancel={() => setShowUpdatePaid(false)}
        handleConfirm={_updatePaid}
        title="ແຈ້ງເຕືອນ"
        loadingConfirm={loadingUpdatePaid}
        text={"ທ່ານຕອ້ງການຈ່າຍເງີນໃບບິນນີ້ ຫຼື ບໍ່"}
      />

    </React.Fragment >
  );
}
